export default "__VITE_ASSET__B7bKJXR3__"